<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<div [id]="getId()" class="modal" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <img (click)="toggle($event)"
                 (keydown.enter)="toggle($event)"
                 (keydown.space)="$event.preventDefault(); toggle($event)"
                 [src]="coverImg" alt="Das Cover des Buches" class="cover-icon"
                 data-bs-toggle="dropdown"
                 tabindex="0"
                 role="button"
            />
            <div class="modal-header">
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>
            <div class="modal-body">

                @if (!applicationStateService.bookConfig.bookPermissions.quickLinks.view && (physicalProductLink || storeLink) && !hasBookAccessCode) {
                    <div
                            class="modal-heading">
                        <button (click)="toggle($event)" aria-expanded="false" aria-haspopup="true"
                                data-bs-toggle="dropdown"
                                id="dropdownMenuButton">
                            <span>Buch kaufen <i aria-hidden="true" class="fa fa-caret-right"></i></span>
                            <div [style.backgroundImage]="'url(' + ('/sidebar-quicklinks/icon-book-shop.png' | asset) + ')'"
                                 class="header-icon-container"></div>
                        </button>
                        <ul aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                            @if (physicalProductLink) {
                                <li class="dropdown-item" href="#"><a [href]="physicalProductLink"
                                                                      target="_blank"><img
                                        [attr.src]="'/sidebar-quicklinks/icon-book-shop.png' |asset"
                                        alt="Icon der Shopping-Seite"/> Gedrucktes
                                    Schulbuch bestellen</a></li>
                            }
                            @if (storeLink) {
                                <li class="dropdown-item" href="#"><a [href]="storeLink" target="_blank"><img
                                        [attr.src]="'/sidebar-quicklinks/store-at-logo.png' |asset"
                                        alt="Icon der Shopping-Seite"/> E-Book auf
                                    Store.at kaufen</a></li>
                            }
                        </ul>
                    </div>
                }

                <div class="quick-link-heading-wrapper">
                    <app-feature-disabled-header [modalable]="modalable"></app-feature-disabled-header>
                    @if (displayDigi4SchoolCodeInformation()) {
                        <app-digi4school-information/>
                    } @else {
                        @if (requiresPremiumPlus || requiresPlus) {
                            <div>
                                <span>Stickercode mit <b>{{ versionTextPlaceholder() }}-Lizenz</b> benötigt</span>
                            </div>
                        } @else {
                            @if (type === ModalService.YEDO) {
                                <div>
                                    @if (modalable && modalable.getStatus() === responseStatus.ERROR) {
                                        <div>
                                            <span>Es ist ein Fehler aufgetreten. Bitte wende Dich an den Support.</span>
                                            <a [href]="contactURL" class="activate-later-button" target="_blank">Support
                                                kontaktieren</a>
                                        </div>
                                    } @else {
                                        <div>
                                            @if (!isLoggedIn) {
                                                <span>
                                                  Diese Funktion setzt einen Account voraus. Bitte melde dich mit deinem Account an.
                                                </span>
                                            }
                                            @if (isLoggedIn) {
                                                <span>
                                                  Bitte gib deinen Yedo Sticker-Code ein, um Yedo Inhalte nutzen zu können.
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            @if (!hasBookAccessCode && type !== ModalService.YEDO) {
                                <div>
                                    Bitte gib den Sticker-Code
                                    ein, {{ type === ModalService.GMT ? 'um zu Mathe-Trainer weitergeleitet zu werden.' : 'um alle Funktionen nutzen zu können.' }}
                                </div>
                            }
                            @if (hasBookAccessCode && type !== ModalService.YEDO) {
                                <div>
                                    @if (isLoggedIn) {
                                        <div>
                                            <span>Es ist ein Fehler aufgetreten. Bitte wende Dich an den Support.</span>
                                            <a [href]="contactURL" class="activate-later-button" target="_blank">Support
                                                kontaktieren</a>
                                        </div>
                                    }
                                    @if (!isLoggedIn) {
                                        <span>
                                          Diese Funktion setzt einen Account voraus. Bitte melde dich mit deinem Account an
                                        </span>
                                    }
                                </div>
                            }
                        }
                    }
                </div>
                @if (userCanSkip()) {
                    <button (click)="onDismissClicked($event)" aria-label="Close" class="activate-later-button"
                            data-bs-dismiss="modal">
                        {{ dismissText }}
                    </button>
                    <div class="or">
                        ODER
                    </div>
                }

                @if (!hasBookAccessCode || (!hasBookAccessCodePlus && requiresPremiumPlus) || (!hasBookAccessCodeNormal && requiresPlus)) {
                    <div class="book-access-code-form-wrapper row">
                        <div class="col-md-7 col-xs-12 code-access-form">
                            <app-book-access-code-form (infoClicked)="onInfoClicked()"
                                                       (sentCode)="onCodeSent($event)"
                                                       [requiresPremiumPlus]="requiresPremiumPlus"></app-book-access-code-form>
                        </div>
                        <div class="col-md-5 col-xs-12">
                            @if (requiresPremiumPlus || requiresPlus) {
                                <ul>
                                    <li class="premium-list">Für diesen Inhalt benötigst du eine <b>{{ versionTextPlaceholder() }}-Lizenz.</b>
                                    </li>
                                    <li class="premium-list">Gib hier deinen {{ versionTextPlaceholder() }}-Stickercode ein.</li>
                                </ul>
                            } @else {
                                <div>
                                    @switch (type) {
                                        @case (ModalService.E_SQUIRREL) {
                                            <ul>
                                                <li>Alle eSquirrel-Funktionen aktivieren</li>
                                                <li>Lernfortschritt speichern</li>
                                            </ul>
                                        }
                                        @case (ModalService.GMT) {
                                            <ul>
                                                <li>Alle Mathe-Trainer-Funktionen aktivieren</li>
                                                <li>Lernfortschritt speichern</li>
                                            </ul>
                                        }
                                        @case (ModalService.HSM) {
                                            <ul>
                                                <li>Alle Aufgaben in der Sidebar wiederfinden</li>
                                                <li>Gesamtübersicht Deiner Stärken und Schwächen samt Empfehlungen
                                                    erstellen
                                                </li>
                                            </ul>
                                        }
                                        @case (ModalService.YEDO) {
                                            <ul>
                                                <li>Alle Inhalte von Yedo nutzen</li>
                                            </ul>
                                        }
                                        @case (ModalService.DIGBI || ModalService.MATHE4ALLE || ModalService.MATHION || ModalService.MATHE_GYM) {
                                            <ul>
                                                <li>Alle Inhalte nutzen</li>
                                            </ul>
                                        }
                                        @case (ModalService.SIA) {
                                            <ul>
                                                <li>Alle Inhalte von SIA Education nutzen</li>
                                            </ul>
                                        }
                                        @default {
                                            <ul>
                                                <li>Alle Buchfunktionen freischalten</li>
                                                <li>Zeichnen & Stempeln</li>
                                                <li>Notizen & Lesezeichen</li>
                                                <li>Seiten exportieren</li>
                                                <li>und vieles mehr!</li>
                                            </ul>
                                        }
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (requiresPremiumPlus || requiresPlus) {
                    <div class="premium-block">
                        <app-feature-disabled-plus [hasBookAccessCode]="hasBookAccessCode"></app-feature-disabled-plus>
                    </div>
                }
                <div class="collapse" id="collapseInfo">
                    <div class="card card-body">
                        <div class="row">
                            <div class="col-md-3 col-xs-12 text-center">
                                <img [src]="'/access-code/schema.png' |asset"
                                     alt="Beispiel eines Buchcovers mit einem Aktivierungscode">
                            </div>
                            <div class="col-md-3 col-xs-12 text-center">
                                <img [src]="'/access-code/pin-example.png' |asset"
                                     alt="Beispiel eines PIN-Stickers">
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <p>Der Sticker-Code ist auf der Titelseite jedes Schulbuchs aufgedruckt.</p>
                                <p>Bei Kauf des E-Books auf Store.at wird der Sticker-Code per E-Mail als PDF zugesendet.</p>
                            </div>
                        </div>
                    </div>
                </div>
                @if (!isLoggedIn) {
                    <div class="register-wrapper">
                        <a [href]="'userGetLogin' |route">Anmelden</a>
                    </div>
                }
                @if (!userCanSkip()) {
                    <div aria-label="Close">
                        <button (click)="onCloseClicked()" aria-label="Close" class="activate-later-button"
                                data-bs-dismiss="modal">
                            Zurück zum Buch
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
